export const IGNORED_PROPERTIES = ['dateOfCreate'];

export const isIgrnoredProperty = (propertyName: string): boolean => {
    return IGNORED_PROPERTIES.includes(propertyName);
};
